<template>
  <vue-modal name="InfoAppeal" :hideCloseBtn="true" :width="width">
    <!-- :on-show="changeForm()" -->

    <modalImg ref="imgzoomC2" :name="'modalImg2'" :arrImg="modalArr" />

    <div class="card mb-0" style="border: none">
      <div class="card-header" style="border-bottom: none; padding: 1rem 0px">
        <h3 class="form-section">
          <i class="icon-info"></i>
          <span class="tag" :class="$t(dataProblem.status.str + '.class')">{{
            $t(dataProblem.status.str + ".title")
          }}</span>
          {{ dataProblem.dateCreate }}
        </h3>
        <div class="heading-elements" style="right: 0px">
          <button
            type="button"
            class="btn btn-warning"
            @click="
              clearDataProbl();
              $modals.hide('InfoAppeal');
            "
          >
            <i style="color: #ffffff" class="icon-cross"></i>
          </button>
        </div>
      </div>
      <div class="card-body">
        <div class="card-block">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group mb-0">
                <h5>{{ $t("tasks.eqMethod.title") }}</h5>
              </div>
              <div class="form-group">
                <span
                  v-for="(serial, index) in dataProblem.serials"
                  :key="index"
                  class="tag tag-default tag-warning"
                  style="margin: 0.2rem"
                >
                  {{ serial }}
                </span>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <fieldset class="form-group position-relative has-icon-left mb-0">
                <textarea
                  id="comment"
                  rows="3"
                  class="form-control border-primary"
                  name="comment"
                  :placeholder="$t('tasks.table.comment')"
                  v-model="dataProblem.comment"
                  disabled
                ></textarea>
                <div class="form-control-position">
                  <i class="icon-file-text"></i>
                </div>
              </fieldset>
            </div>
          </div>

          <div class="row" v-if="dataProblem.images.length > 0">
            <div class="col-md-12">
              <form class="form">
                <h4 class="form-section">
                  <i class="icon-images2"></i> {{ $t("tasks.table.images") }}
                </h4>
              </form>
              <div class="row">
                <div class="col-md-12" style="display: flex; flex-wrap: wrap">
                  <div
                    class="col-xs-2"
                    style="
                      padding: 0;
                      display: flex;
                      flex-direction: column;
                      align-content: center;
                      justify-content: center;
                      margin-bottom: 1em;
                    "
                    v-for="(image, index) in dataProblem.images"
                    :key="index"
                  >
                    <div class="card hand mb-0" style="margin-left: 5px">
                      <div class="w-100 h-100">
                        <!-- <i class="icon-cross delete-image-icon" @click="dataProblem.images.splice(index, 1); dataProblem.images2.splice(index, 1);" data-html="true" :title=" $t('tasks.hint.delImg')"></i> -->
                        <img
                          :src="image"
                          style="max-width: 100%; max-height: 100%"
                          @click="expandDiv(dataProblem.images, index)"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row mb-1" v-if="dataProblem.checks.length > 0">
            <div class="col-md-12">
              <div class="form-group mb-0">
                <h5>{{ $t("problem.table.probl_categ") }}</h5>
              </div>
            </div>

            <div
              class="col-md-3"
              v-for="(gr, ind) in dataProblem.checks"
              :key="ind"
            >
              <i
                style="vertical-align: middle; margin-left: 5px"
                class="font-large-1"
                :class="gr.class"
              ></i>
              <span
                style="
                  vertical-align: middle;
                  font-size: 1.3em;
                  max-width: 80%;
                  margin-left: 5px;
                "
              >
                {{ $t(gr.title) }}</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </vue-modal>
</template>

<script>
export default {
  name: "ModalAppealInfo",
  data() {
    return {
      width: null,
      modalArr: [],
      dataProblem: {
        guidProblem: "",
        serials: [],
        serial: null,
        comment: null,
        dateCreate: null,
        coordinate: {
          latitude: null,
          longitude: null,
          accuracy: null,
        },
        status: { str: null, id: null },
        images: [],
        images2: [],
        checks: [],

        taskNumber: null,
        taskGuid: null,
      },
    };
  },
  components: {},
  props: {},
  methods: {
    changeForm() {
      //document.getElementsByClassName('v-modal__heading').style.padding = '0px';
      /*setTimeout( () => {
                    $('.v-modal__heading').css({"padding":"0px"});
                },500 
            );*/
    },
    getInfoProblem(guid) {
      this.clearDataProbl();
      let dataRequest = { guid: guid };

      this.makeQuery2("/service/getInfoProblem", {
        dataRequest: dataRequest,
        token: this.$store.getters.getUserToken,
      })
        .then((result) => {
          if (!result || !result.data || !result.data.data) {
            this.clearDataProbl();
            this.$modals.hide("InfoAppeal");
            this.showNotification("custom-error", "Error", result);
            return;
          }
          this.dataProblem.serial = result.data.data.serial;

          this.dataProblem.guidProblem = guid;

          let serials = this.dataProblem.serial.split(",");
          for (let i = 0; i < serials.length; i++) {
            this.dataProblem.serials.push(serials[i]);
          }

          this.dataProblem.comment = result.data.data.description;
          this.dataProblem.dateCreate = this.dtFormat(
            result.data.data.dateCreate
          );
          //this.dataProblem.position.latitude = ;
          //this.dataProblem.position.longitude = ;

          if (result.data.data.task) {
            this.dataProblem.taskNumber = result.data.data.task.name;
            this.dataProblem.taskGuid = result.data.data.task.id;
          }

          let arr_img = [],
            mark_old = false;

          if (
            result &&
            result.data &&
            result.data.data &&
            result.data.data.signed_urls &&
            Array.isArray(result.data.data.signed_urls)
          ) {
            arr_img = result.data.data.signed_urls;
          }
          if (
            result &&
            result.data &&
            result.data.data &&
            result.data.data.files &&
            Array.isArray(result.data.data.files)
          ) {
            arr_img = result.data.data.files;
            mark_old = true;
          }
          if (arr_img.length) {
            for (let i = 0; i < arr_img.length; i++) {
              if (mark_old) {
                this.dataProblem.images.push(arr_img[i].link + "/preview");
              } else {
                this.dataProblem.images.push(arr_img[i].url);
              }
            }
          }

          this.dataProblem.checks = [];

          /*if(result.categories != undefined){
                        for (let i = 0; i < result.categories.length; i++) {
                            for (let j = 0; j < this.$store.state.categories.length; j++) {
                                if(this.$store.state.categories[j].id == result.categories[i].id){
                                    //this.categories[j].checked = result.categories[i].value;
                                    if(result.categories[i].value == true){
                                        this.dataProblem.checks.push({
                                            id: this.$store.state.categories[j].id,
                                            guid: result.categories[i].guidProblemEquipment,
                                            title: this.$store.state.categories[j].title,
                                            class: this.$store.state.categories[j].class,
                                            checked: result.categories[i].value
                                        });
                                    }
                                    break;
                                }
                            }
                        }
                    }*/

          if (result.data.data.status != undefined) {
            if (result.data.data.status == 1) {
              this.dataProblem.status.str = "tasks.statuses.new";
              this.dataProblem.status.id = result.data.data.status;
            } else if (result.data.data.status == 2) {
              this.dataProblem.status.str = "tasks.statuses.process";
              this.dataProblem.status.id = result.data.data.status;
            } else if (result.data.data.status == 3) {
              this.dataProblem.status.str = "tasks.statuses.done";
              this.dataProblem.status.id = result.data.data.status;
            } else if (result.data.data.status == 4) {
              this.dataProblem.status.str = "tasks.statuses.cancel";
              this.dataProblem.status.id = result.data.data.status;
            }
          }

          $(".v-modal__heading").css({ padding: "0px" });
        })
        .catch((result) => {
          this.clearDataProbl();
          this.$modals.hide("InfoAppeal");
          this.showNotification("custom-error", "Error", result);
        });
    },
    clearDataProbl() {
      this.dataProblem.serial = null;
      this.dataProblem.guidProblem = "";
      this.dataProblem.serials = [];
      this.dataProblem.images = [];
      this.dataProblem.images2 = [];
      this.dataProblem.comment = null;
      this.dataProblem.coordinate.latitude = null;
      this.dataProblem.coordinate.longitude = null;
      this.dataProblem.coordinate.accuracy = null;
      this.dataProblem.dateCreate = null;
      this.dataProblem.status.id = null;
      this.dataProblem.status.str = null;
      this.dataProblem.taskNumber = null;
      this.dataProblem.taskGuid = null;
    },
    expandDiv(arr, ind) {
      $("#modalImg2").modal("show");
      this.$refs.imgzoomC2.onShow(ind, arr);
      /*
            var img = new Image;
            this.modalArr = arr;

            img.onload = () => {
                $('#modalImg2').modal('show');
                this.$refs.imgzoomC.onShow(ind);
            };
            img.src = arr[ind].data;*/
    },
  },
  computed: {},
  mounted() {},
  watch: {},
  created() {
    //this.width = window.innerWidth * 0.8;
    this.width = document.body.clientWidth * 0.9;
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/ModalAppealInfo.vue